// @ts-nocheck
import { InvoiceModel } from "@insite/client-framework/Types/ApiModels";

const getInvoicesTermDiscount = (invoices: InvoiceModel[]) => {
    const amount = invoices.reduce((sum, invoice) => {
        return sum + (invoice.discountedAmount || 0);
    }, 0);

    return parseFloat(amount.toFixed(2));
};

export default getInvoicesTermDiscount;
